import { addValidationRule } from '@akihirotakamura/formsy-react'
import moment from 'moment'

addValidationRule('isDateTimeSecond', (values, value) => {
  if (!value || value === '') return true
  const plain = value.toString().replace(/[\u002f\u003a\u0020]/g, '')
  return plain.match(/[0-9]{14}/) && moment(value, 'YYYYMMDDHHmmss').isValid()
})
